export const THEMES = [
  {
    id: "work",
    label: "仕事運",
    emoji: "💼",
    color: "#92400e",
    bg: "#fef3c7",
    keywords: ["商売", "金運", "財運", "富", "開運", "勝運", "武運", "学業", "合格", "知恵", "学問", "受験"],
    timing: "朝の清々しい時間（6〜9時頃）の参拝がおすすめです。澄んだ空気の中で一日の意図を定めましょう。",
    prayerQ: "今の仕事でどんな力が必要ですか？具体的に思い浮かべながら参拝してみましょう。",
    action: "帰り道に、今日取り組む具体的な一歩を一つだけ決めてみましょう。",
  },
  {
    id: "love",
    label: "恋愛・結婚",
    emoji: "💗",
    color: "#be185d",
    bg: "#fce7f3",
    keywords: ["縁結", "恋愛", "良縁", "縁"],
    timing: "縁起の良い日（一粒万倍日・天赦日）や夕暮れ時が良いとされています。",
    prayerQ: "どんな縁を結びたいですか？相手への感謝と自分への正直さを大切に。",
    action: "自分自身を大切にすることが良縁を引き寄せます。今日一つ、自分への優しさを実践してみましょう。",
  },
  {
    id: "health",
    label: "健康",
    emoji: "🌿",
    color: "#166534",
    bg: "#dcfce7",
    keywords: ["健康", "病気", "無病", "長寿", "延命", "医", "安産", "子宝"],
    timing: "朝の澄んだ空気の中での参拝が心身を清めます。早起きして参拝するのが吉。",
    prayerQ: "今、体や心で気になる部分はありますか？感謝の気持ちを込めて参拝しましょう。",
    action: "参拝後に深呼吸を10回。自分の体への感謝を忘れずに一日を過ごしましょう。",
  },
  {
    id: "family",
    label: "家族・先祖",
    emoji: "🏡",
    color: "#9a3412",
    bg: "#fff7ed",
    keywords: ["家内安全", "家庭", "家族", "安産", "子宝", "子育"],
    timing: "お朔日（月初め）や家族の記念日・法要の際の参拝がおすすめです。",
    prayerQ: "大切な家族・先祖への感謝を心に浮かべながら参拝してみましょう。",
    action: "帰宅したら、大切な人に一言感謝を伝えてみましょう。",
  },
  {
    id: "money",
    label: "金運",
    emoji: "✨",
    color: "#b45309",
    bg: "#fffbeb",
    keywords: ["商売", "金運", "財運", "富", "開運", "招福", "幸運", "五穀", "豊穣", "農業"],
    timing: "巳の日（12日ごと）や一粒万倍日の参拝が良いとされています。",
    prayerQ: "お金をどのように使いたいですか？感謝と謙虚さを大切にして参拝を。",
    action: "財布の中を整理して、お金への感謝の気持ちを持ちましょう。",
  },
  {
    id: "calm",
    label: "心を落ち着けたい",
    emoji: "🌸",
    color: "#5b21b6",
    bg: "#ede9fe",
    keywords: ["厄除", "魔除", "除災", "邪気", "芸能", "技芸", "芸術", "音楽"],
    timing: "日没前後の静かな時間帯が心を落ち着けるのに適しています。",
    prayerQ: "今、手放したいものは何ですか？神様に預けるつもりで参拝してみましょう。",
    action: "参拝後5分、スマホを置いて境内で静かに過ごしてみましょう。",
  },
  {
    id: "relationship",
    label: "人間関係",
    emoji: "🤝",
    color: "#0369a1",
    bg: "#e0f2fe",
    keywords: ["縁結", "縁", "家内安全", "家庭", "厄除"],
    timing: "人が少ない静かな時間に参拝すると気持ちが整いやすいです。",
    prayerQ: "気になっている人間関係について、自分の部分を見つめてみましょう。",
    action: "苦手な人を一人思い浮かべて、その人の良いところを一つ探してみましょう。",
  },
];

export const SITUATIONS = [
  { label: "仕事や目標を前に進めたい", themeId: "work" },
  { label: "大切な人との縁を深めたい", themeId: "love" },
  { label: "体や心の疲れを癒したい", themeId: "health" },
  { label: "家族・先祖への感謝を伝えたい", themeId: "family" },
  { label: "豊かさや余裕を引き寄せたい", themeId: "money" },
  { label: "もやもやをリセットしたい", themeId: "calm" },
  { label: "人間関係をすっきりさせたい", themeId: "relationship" },
];

export function getThemeById(id) {
  return THEMES.find((t) => t.id === id) || null;
}

export function scoreShrine(shrine, theme, deityMap) {
  if (!shrine.deities?.length) return 0;
  let score = 0;
  for (const deity of shrine.deities) {
    const attrs = deityMap[deity.name] || [];
    for (const attr of attrs) {
      if (theme.keywords.some((k) => attr.includes(k))) score++;
    }
  }
  return score;
}

export function getPrimaryThemes(shrine, deityMap) {
  return THEMES.map((t) => ({ theme: t, score: scoreShrine(shrine, t, deityMap) }))
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 3)
    .map(({ theme }) => theme);
}
